module.exports = __webpack_public_path__ + "static/media/logo.527cf4c4.png";